/** The subset of i18next's `t` needed to translate with a fallback. */
export type EnumLabelTranslate = (
  key: string,
  options?: { defaultValue: string },
) => string;

/** Localized label for a backend enum value; the raw value when no `${prefix}.${value}` key exists. */
export function enumLabel(
  prefix: string,
  value: string,
  t: EnumLabelTranslate,
): string {
  return t(`${prefix}.${value}`, { defaultValue: value });
}
